/*
validate-username-api.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
define('validateUsernameApi',['angular'], function () {

    // Module Dependencies
    var dependencies = [];

    // Module Definition
    var mod = angular.module('Services.ValidateUsernameApi', dependencies);

    /**
     * @name validateUsernameApi
     * @type factory
     *
     * @description
     * A factory that provides methods for validating Username/Email.
     */
    mod.factory('validateUsernameApi', ['$q', function ($q) {
        /**
         * Base url for requests to the Valid User check REST API.
         */
        var BASE_URL = '/v1/umgmt/guest/users/password/forgot';
        var CAPTCHA_URL = '/validateCaptcha';
        var OTP_URL = '/mobile-verification/getVerificationCode';
        var VERIFY_OTP_URL = '/mobile-verification/verifyOTP';
        var ACCESS_CODE_VALIDATE_URL = '/validateAccessionNumber';
        var IS_CAPTCHA_ENABLED_URL = '/isCaptchaEnabled';
        var GET_USER_ORG_DETAILS = "/v1/umgmt/guest/users/smsFlagEnabled";
        var GET_MOBILENUMBER = "/mobile-verification/getMobileNo";
        var OTP_URL_EMAIL = "/v1/umgmt/guest/users/getVerificationCodeOnEmail";
        var VERIFY_OTP_EMAIL = "/v1/umgmt/guest/users/verifyOTPForEmail";

        //To get browser's language
        var locale = window.Messages('inbox.localeCode').toLowerCase();

        /**
         * Verifys Captcha at Play layer
         * @params
         * captcha: Captcha text
         * guid: GUID that is attached to the current cpatcha session.
         *
         * @return
         *    A promise that will be resolved/rejected once a response is received.
         */
        function validateCaptcha(captcha, guid) {
            var deferred = $q.defer(),
                url = CAPTCHA_URL + '?captcha-text=' + captcha + '&uuid=' + guid;

            // send the request
            $.ajax({
                async: false,
                dataType: 'json',
                type: 'get',
                url: url,
                success: success,
                error: error
            });

            return deferred.promise;

            function success(data) {
                deferred.resolve(data || null);
            }

            function error(jqXHR) {
                var errorMsg = jqXHR.responseText ? JSON.parse(jqXHR.responseText).message : "";
                deferred.reject(errorMsg);
            }
        }

        /**
         * Verifies whether the access code belongs to the given site
         * @params
         * accessCode: access code
         * id: site entity id
         * siteId: site id
         *
         * @return
         *    A promise that will be resolved/rejected once a response is received.
         */
        function validateAccessCode(accessCode, siteId, id, firstName, lastName) {
            var deferred = $q.defer(),
                url = ACCESS_CODE_VALIDATE_URL;

            var data = {
                "accessCode": accessCode,
                "siteId": siteId,
                "id": "" + id,
                "patientName": lastName + '^' + firstName
            };

            // send the request
            $.ajax({
                async: true,
                contentType: 'application/json',
                dataType: 'json',
                type: 'post',
                url: url,
                data: JSON.stringify(data),
                success: success,
                error: error
            });

            return deferred.promise;

            function success(data) {
                deferred.resolve(data || null);
            }

            function error(jqXHR) {
                var errorMsg = jqXHR.responseText ? JSON.parse(jqXHR.responseText).message : "";
                deferred.reject(errorMsg);
            }
        }

        /**
         * Checks for valid user in Centricity360.
         *
         * @param
         * email: The email added by user.
         * captcha: Captcha text
         * guid: GUID that is attached to the current cpatcha session.
         *
         * @param settings.async
         *    By default, all requests are sent asynchronously (i.e. this is set to true by default).
         *    If you need synchronous requests, set this option to false. Please note that synchronous
         *    requests may temporarily lock the browser, disabling any actions while the request is active.
         *
         * @return
         *    A promise that will be resolved/rejected once a response is received.
         */
        function validateUsername(email, captcha, guid, isSMSVerified) {
            // validate arguments
            if (!email) {
                var errorMsg = 'Error: validateUsernameApi: validateUsername: invalid parameter: email = ' + email;
                return $q.reject(errorMsg);
            }

            email = encodeURIComponent(email);

            var deferred = $q.defer(),
                url = BASE_URL + '?email=' + email + '&captcha-text=' + captcha + '&uuid=' + guid + '&isSMSVerified=' + isSMSVerified;

            // send the request
            $.ajax({
                async: true,
                dataType: 'json',
                type: 'get',
                url: url,
                success: success,
                error: error
            });

            return deferred.promise;

            function success(data) {
                deferred.resolve(data || null);
            }

            function error(jqXHR) {
                var errorMsg = jqXHR.responseText ? JSON.parse(jqXHR.responseText).message : "";
                deferred.reject(errorMsg);
            }
        }

        /**
         * @param
         * mobileNumber: mobileNumber that is entered by user.
         * countryCode: countryCode that is entered by user.
         *
         *  @param settings.async
         *    By default, all requests are sent asynchronously (i.e. this is set to true by default).
         *    If you need synchronous requests, set this option to false. Please note that synchronous
         *    requests may temporarily lock the browser, disabling any actions while the request is active.
         *
         * @return
         *    A promise that will be resolved/rejected once a response is received.
         */

        function getOTP(mobileNumber, countryCode, email) {
            //To get browser's language
            var locale = window.Messages('inbox.localeCode').toLowerCase();
            var mobileNoWithCountryCode = countryCode + "-" + mobileNumber;
            var deferred = $q.defer(),
                url = OTP_URL + '?emailId=' + email + '&mobileNumber=' + mobileNoWithCountryCode + '&locale=' + locale;

            // send the request
            $.ajax({
                async: false,
                dataType: 'text',
                type: 'get',
                url: url,
                cache: false,
                success: success,
                error: error
            });

            return deferred.promise;

            function success(data, textStatus, jqXHR) {
                var response1 = jqXHR.responseText || null;
                deferred.resolve(response1);
            }

            function error(jqXHR, textStatus, errorThrown) {
                var errorMsg = 'Error: Get OTP: ' + errorThrown;
                console.log(errorMsg);
                deferred.reject(jqXHR);
            }
        }

        /**
         * @param
         * otp: otp that is entered by user.
         * mobileNumber: mobileNumber that is entered by user.
         *
         * @return
         *    A promise that will be resolved/rejected once a response is received.
         */
        function verifyOTP(otp, mobileNumber, email) {
            mobileNumber = mobileNumber.substring(1, mobileNumber.length);
            var deferred = $q.defer(),
                url = VERIFY_OTP_URL + '?otp=' + otp + '&mobileNumber=' + mobileNumber + '&emailId=' + email;

            // send the request
            $.ajax({
                async: false,
                cache: false,
                dataType: 'text',
                type: 'get',
                url: url,
                success: success,
                error: error
            });


            function success(data) {
                deferred.resolve(data || null);
            }

            function error(jqXHR, textStatus, errorThrown) {
                var errorMsg = 'Error: Get OTP: ' + errorThrown;
                console.log(errorMsg);
                deferred.reject(jqXHR);
            }

            return deferred.promise;
        }


        function sendOTPForPwdReset(email, isTwoFactorAuth, otpValidation) {
            var deferred = $q.defer(), url, js_signature = "";
            if (otpValidation === "EMAIL") {
                url = OTP_URL_EMAIL + '?locale=' + locale;
            } else {
                if (isTwoFactorAuth) {
                    url = '/mobile-verification/getSecondFactorAuthOTP' + '/' + locale;
                } else {
                    url = '/mobile-verification/getPwdResetOTP' + '/' + email + '?locale=' + locale;
                    js_signature = signature;
                }
            }


            // send the request
            $.ajax({
                headers: {'js-sig': js_signature},
                async: false,
                dataType: 'text',
                type: 'get',
                url: url,
                cache: false,
                success: success,
                error: error
            });

            return deferred.promise;

            function success(data, textStatus, jqXHR) {
                var response1 = jqXHR.responseText || null;
                deferred.resolve(response1);
            }

            function error(jqXHR, textStatus, errorThrown) {
                var errorMsg = 'Error: Get sendOTPForPwdReset: ' + errorThrown;
                console.log(errorMsg);
                deferred.reject(jqXHR);
            }
        }

        function verifyOTPForPwdReset(otp, mobileNumber, email, otpValidation, isTwoFactorAuth) {
            var deferred = $q.defer(), url;
            if (otpValidation === "EMAIL") {
                url = VERIFY_OTP_EMAIL + '?otp=' + otp + '&emailId=' + email;
            } else {
                if (isTwoFactorAuth) {
                    url = '/mobile-verification/verifyOTPForSecondFactor' + '?otp=' + otp;
                } else {
                    url = '/mobile-verification/verifyOTPForPwdReset' + '?otp=' + otp + '&emailId=' + encodeURIComponent(email);

                }

            }


            // send the request
            $.ajax({
                async: false,
                cache: false,
                dataType: 'text',
                type: 'get',
                url: url,
                success: success,
                error: error
            });

            return deferred.promise;

            function success(data, textStatus, jqXHR) {
                var response1 = jqXHR.responseText || null;
                deferred.resolve(response1);
            }

            function error(jqXHR, textStatus, errorThrown) {
                var errorMsg = 'Error: Get sendOTPForPwdReset: ' + errorThrown;
                console.log(errorMsg);
                deferred.reject(jqXHR);
            }
        }

        /**
         * @param
         *   ---
         *
         * @return
         *    A promise that will be resolved/rejected once a response is received.
         */
        function isCaptchaEnabled() {
            var deferred = $q.defer();


            // send the request
            $.ajax({
                async: false,
                dataType: 'text',
                type: 'get',
                url: IS_CAPTCHA_ENABLED_URL,
                success: success,
                error: error
            });


            function success(data) {
                deferred.resolve(data || null);
            }

            function error(jqXHR, textStatus, errorThrown) {
                var errorMsg = 'Error: Get isCaptchaEnabled: ' + errorThrown;
                console.log(errorMsg);
                deferred.reject(jqXHR);
            }

            return deferred.promise;
        }

        /**
         * @param
         *   ---
         *
         * @return
         *    A promise that will be resolved/rejected once a response is received.
         */
        function fetchUserOrgDetails(email) {
            var deferred = $q.defer(),
                url = GET_USER_ORG_DETAILS + '?email=' + encodeURIComponent(email);


            // send the request
            $.ajax({
                async: false,
                dataType: 'json',
                type: 'get',
                url: url,
                success: success,
                error: error
            });


            function success(data) {
                deferred.resolve(data || null);
            }

            function error(jqXHR, textStatus, errorThrown) {
                var errorMsg = 'Error: Get fetchUserOrgDetails: ' + errorThrown;
                console.log(errorMsg);
                deferred.reject(jqXHR);
            }

            return deferred.promise;
        }

        /**
         * @param
         *   enail:username from session storage
         *
         * @return
         *    A promise that will be resolved/rejected once a response is received.
         */
        function getMobileNumber() {
            var deferred = $q.defer(),
                url = GET_MOBILENUMBER;


            // send the request
            $.ajax({
                async: false,
                type: 'get',
                url: url,
                success: success,
                error: error,
                cache: false
            });


            function success(data) {
                deferred.resolve(data || null);
            }

            function error(jqXHR, textStatus, errorThrown) {
                var errorMsg = 'Error: Get fetchUserOrgDetails: ' + errorThrown;
                console.log(errorMsg);
                deferred.reject(jqXHR);
            }

            return deferred.promise;
        }


        /**
         * Public API
         */
        return {
            // GET
            validateUsername: validateUsername,
            validateCaptcha: validateCaptcha,
            validateAccessCode: validateAccessCode,
            getOTP: getOTP,
            verifyOTP: verifyOTP,
            sendOTPForPwdReset: sendOTPForPwdReset,
            verifyOTPForPwdReset: verifyOTPForPwdReset,
            isCaptchaEnabled: isCaptchaEnabled,
            fetchUserOrgDetails: fetchUserOrgDetails,
            getMobileNumber: getMobileNumber
        };

    }]);

});

